// Stable asset-class color palette for all charts.
// Keys cover both Italian labels (from the DB / clients aggregate) and English
// labels (from ASSET_CLASS_KEY_LABELS in banker_flow_page.py). Both sets map
// to the same canonical per-asset-class color so charts are consistent.
// Unknown labels fall back to a rotating set so the chart still renders.

const PALETTE: Record<string, string> = {
  // Italian labels (DB / ClientsAggregateInsight)
  Azionario: '#F1BD0E',
  Monetario: '#B4E4F1',
  'Obbligazionario Governativo': '#D2EC74',
  'Obbligazionario High Yield': '#57D066',
  'Obbligazionario Corporate IG': '#D8D8D8',
  'Obbligazionario Corporate Investment Grade': '#D8D8D8',
  'Obbligazionario Paesi Emergenti': '#C59398',
  Derivati: '#93F8F3',

  // English labels (AllocationDonut / banker-flow charts)
  Equity: '#F1BD0E',
  Monetary: '#B4E4F1',
  'Government bonds': '#D2EC74',
  'High-yield bonds': '#57D066',
  'Investment-grade bonds': '#D8D8D8',
  'Emerging-market bonds': '#C59398',

  // Catch-alls
  Bonds: '#D8D8D8',
  Liquidity: '#B4E4F1',
  'Multi-asset': '#D2EC74',
  Alternatives: '#93F8F3',
  Other: '#D8D8D8',
  Unclassified: '#D8D8D8',
}

const FALLBACK = [
  '#F1BD0E',
  '#B4E4F1',
  '#D2EC74',
  '#57D066',
  '#D8D8D8',
  '#C59398',
  '#93F8F3',
  '#F1BD0E',
]

export function colorForLabel(label: string, index: number): string {
  if (PALETTE[label]) return PALETTE[label]
  return FALLBACK[index % FALLBACK.length]
}
